import api_comm from "./lib";

async function validateIMEI(claim, session_token) {
	let product_identifier = claim.device_serial?.split("\n");

	let identifiers = {
		identifiers: product_identifier,
	};

	return api_comm(
		"post",
		`/claims/api/v2/claim/verify/${claim.store_guid}`,
		identifiers,
		session_token
	);
}

export default validateIMEI;
